import { graphql } from '../generated';

export const START_CHECKOUT = graphql(`
  mutation StartCheckout($input: StartCheckoutInput!) {
    startCheckout(input: $input) {
      transactionId
      userErrors {
        code
        message
      }
    }
  }
`);

export const CHANGE_PLAN = graphql(`
  mutation ChangePlan($input: ChangePlanInput!) {
    changePlan(input: $input) {
      subscription {
        ...SubscriptionFields
      }
      userErrors {
        code
        message
      }
    }
  }
`);

export const CANCEL_PLAN = graphql(`
  mutation CancelPlan {
    cancelPlan {
      subscription {
        ...SubscriptionFields
      }
      userErrors {
        code
        message
      }
    }
  }
`);

export const KEEP_PLAN = graphql(`
  mutation KeepPlan {
    keepPlan {
      subscription {
        ...SubscriptionFields
      }
      userErrors {
        code
        message
      }
    }
  }
`);

export const UPDATE_PAYMENT_METHOD = graphql(`
  mutation UpdatePaymentMethod {
    updatePaymentMethod {
      transactionId
      userErrors {
        code
        message
      }
    }
  }
`);

export const PAY_INVOICE = graphql(`
  mutation PayInvoice($input: PayInvoiceInput!) {
    payInvoice(input: $input) {
      transactionId
      userErrors {
        code
        message
      }
    }
  }
`);

export const INVOICE_PDF = graphql(`
  mutation InvoicePdf($input: InvoicePdfInput!) {
    invoicePdf(input: $input) {
      url
      userErrors {
        code
        message
      }
    }
  }
`);

export const UPDATE_BILLING_EMAIL = graphql(`
  mutation UpdateBillingEmail($input: UpdateBillingEmailInput!) {
    updateBillingEmail(input: $input) {
      billing {
        ...BillingFields
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`);
